import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { ToastService } from '../services/toast.service';
import { NGXLogger } from 'ngx-logger';
import { environment } from '../../../environments/environment';

export const errorHandlerInterceptor: HttpInterceptorFn = (req, next) => {
  
  // const errorHandlerSv = inject(ErrorHandlerService);
  const toast = inject(ToastService);
  const logger: NGXLogger = inject(NGXLogger);

  return next(req).pipe(
    tap({
      next: (event) => {
        if(event instanceof HttpResponse) {
          // toast.show('Success.', 'Http request success', 'success');
        }
      },
      error: (error: HttpErrorResponse) => {
        // console.log('Handler: ', error)
        // toast.show('Error.', error.error.error, 'error');
        /**
         * Storing logs only for production mode
         */
        if(environment.production) {
          logger.error('HTTP Error ', {
            url: req.url,
            status: error.status,
            message: error.message,
            error: error.error
          });
        }
      }
    })
  )
  
};
